import { ReactNode } from "react";
import { useEvalSubscription } from "../eval/hooks/userEvalSubscription";
import { ActionBlocker, ActionBlockerProps } from "./ActionBlocker";
import { appConfig } from "../../app-config";

export function EvalActionBlocker(props: ActionBlockerProps){
    const { isTrial, isTrialEnded: isTrialExpired } = useEvalSubscription();

    let tooltip: ReactNode = "";
    if(!isTrial && !isTrialExpired) {
        tooltip = "Start your free EVAL™ trial to receive full access";
    } else {
        tooltip = <>Limited features. Contact <a href={`mailto:${appConfig.salesEmail}`}>{appConfig.salesEmail}</a></>
    }

    return <ActionBlocker tooltipContent={tooltip} {...props} />
}

